import React from "react";
import "./Text.css";

interface TextProps {
  content: string;
  className?: string;
}

const Text: React.FC<TextProps> = ({ content, className }) => {
  return <span className={`option-text ${className ?? ""}`}>{content}</span>;
};

export default Text;
